// Re-export port data loaded at runtime; this module provides the static
// region colour map used by the map layer.
export const REGION_COLORS = {
  europe_north:    '#4a90d9',
  europe_south:    '#5ba85b',
  asia_southeast:  '#269ea7',
  asia_east:       '#279c3c',
  asia_south:      '#9b59b6',
  americas_north:  '#1abc9c',
  americas_south:  '#d33cd2',
  africa:          '#36de82',
  middle_east:     '#d30480',
  oceania:         '#16a085'
};

/**
 * The four canonical starting ports a new (or reset) player can begin at —
 * one per major trading region, matching what registration has always
 * defaulted to (server/game/bootstrap.js's DEFAULT_START_PORT_ID, index 0
 * here). Shared between client (GameMenuModal's reset port picker) and
 * server (runtime.js's resetPlayer() validates against this same list) so
 * the two can never drift apart.
 */
export const STARTING_PORT_IDS = ['gdansk', 'piraeus', 'penang', 'cartagena'];
